import useRemoteConfig from './useRemoteConfig'

export default function useSmartcarSdk({
  vehicleMake,
}: {
  vehicleMake: string
}) {
  const { appRemoteConfig } = useRemoteConfig()
  const useSdk =
    appRemoteConfig?.getBoolean('smartcar_sdk_enabled') &&
    appRemoteConfig
      .getArray('smartcar_sdk_makes')
      .map((make) => make.toLowerCase())
      .includes(vehicleMake.toLowerCase())

  return { useSdk }
}
